import styled from 'styled-components';

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BlueHeader = styled.div`
  position: relative;
  background: linear-gradient(180deg, #296bcd 0%, #245499 100%);
  color: white;
  padding: 28px 20px;
  text-align: center;
`;

export const HeaderTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  text-align: center;
  color: #ffffff;
`;

export const HeaderSubtitle = styled.p`
  font-size: 14px;
  color: #ffffff;
  font-weight: 400;
`;

export const FormBody = styled.div`
  padding: 40px 60px;
  background: white;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #212529;
  margin-bottom: 5px;
  &.service {
    margin-top: 20px;
  }
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 15px;
  padding: 0 40px 40px;
  background: white;
  @media (max-width: 768px) {
    padding: 16px 16px;
  }

  button {
    flex: 1;
    height: 44px;
    border-radius: 8px;
    font-weight: 700;
  }

  .modal-button-cancel {
    color: #a0aec0;
    border: 1px solid #e2e8f0;
  }

  .modal-button-save {
    background: linear-gradient(86.07deg, #2969c9 19.44%, #255aa5 101.76%);
    color: white;
  }
`;

export const CharCount = styled.div`
  width: 390px;
  text-align: right;
  font-size: 13px;
  color: #a0aec0;
  margin-top: 4px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const StyledTextareaWrapper = styled.div`
  width: 390px;

  textarea {
    width: 390px !important;
    height: 112px !important;
    min-height: 112px;
    max-height: 112px;
    resize: none;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px;
    @media (max-width: 768px) {
      width: 100% !important;
    }
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const FieldGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

export const DatesRow = styled.div`
  display: flex;
  gap: 6px;
  width: 390px;
  justify-content: space-between;
  margin-top: 20px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const DateInputWrapper = styled.div`
  flex: 1;

  label {
    font-size: 13px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 5px;
  }
`;

export const ErrorMessage = styled.div`
  margin: 0 40px 16px;
  padding: 12px;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
  color: #dc3545;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  @media (max-width: 768px) {
    margin: 0 16px 16px;
  }
`;
